import React, { useState } from 'react';
import { IoIosArrowForward } from "react-icons/io";
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import moreData from '../../more.json';
import portfolioData from '../../portfoli.json';


const MainPortfolio = () => {
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  return (
    <PortfolioBox>
      <ul onWheel={(e) => {
        if (open) {
          e.stopPropagation();
          return;
        }
      }}>
        {portfolioData.porfolio.map((item) => (
          <li key={item.id} style={{ backgroundImage: `url(${item.thumnail})`, flex: 'initial' }} onClick={() => navigate(`/portfolio/#${item.navigator}`)} >

            <h5>
              <img
                src={item.logo} alt={item.title} />
            </h5>

          </li>
        ))}
        <li className="more-box" onClick={onOpenModal}>
          <div className="more-text">
            <div>MORE</div>
            <IoIosArrowForward size={42} color={'#fff'} />
          </div>
        </li>

        <Modal open={open} onClose={onCloseModal} center>
          <div className="more-modal position-relative">
            <img src="/assets/icon/topping.svg" className="more-logo" alet="topping_logo" />
            <div>
              <h2 className="more-title">TOPPING PORTFOLIO MORE..</h2>
            </div>

            <div>
              {moreData.more.map((item) => (
                <div key={item.id} className="more-table">
                  <div dangerouslySetInnerHTML={{ __html: item.title }}></div>
                  <div dangerouslySetInnerHTML={{ __html: item.subject }}></div>
                </div>
              ))}
            </div>
          </div>
        </Modal>
      </ul>
    </PortfolioBox>
  );
};

const PortfolioBox = styled.div`
padding:160px 0 0;
  ul{
    display: flex;
    flex-wrap: wrap;
  }
  li{
    flex:1 1 auto;
    width: 33%;
    height: 321px;
    background-position: center;
    background-repeat: no-repeat;
    background-color: rgba(0, 0, 0, 0.20);
    background-size: cover;
    background-blend-mode: multiply;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    img{
      opacity: 0.8;
      filter: drop-shadow(0px 4px 50px rgba(0, 0, 0, 0.05));
      transition: all 0.3s;
      height: 50px;
    }
    &:after{
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      border: 1px solid #fff;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      opacity: 0;
      transition: all 0.7s;
    }
    &:hover{
      &::after{
        border: 10px solid #fff;
        width: 85%;
        height:85%;
        opacity: 1;
      }
      img{
        opacity: 1;
      }
    }
  }
`;

export default MainPortfolio;